module.exports = __webpack_public_path__ + "img/5.a23d4704.jpg";